/**
 * The key facts as chips under a listing's title (P25009-486 BR-4):
 * "Dubb · Nya · 7,5×18 ET42 · 5×108". What a buyer checks before reading
 * anything else — tyre type, condition, rim size with offset, bolt pattern —
 * each only when the listing actually states it.
 */

import { boltCircleText } from './boltCircleCore';

/* Tyre type, shortened the way the mockup writes it. */
const TYRE_TYPE_CHIPS = {
  summer: 'Sommar',
  winterFriction: 'Friktion',
  winterDubbed: 'Dubb',
  allSeason: 'Helår',
};

/* Console enum keys write the decimal point as "_" ("7_5", "114_3"); a buyer
 * reads a decimal comma. */
const decimal = value =>
  String(value)
    .trim()
    .replace(/["”″]/g, '')
    .replace(/[._]/, ',');

/**
 * @param {Object} publicData listing publicData
 * @returns {Array<string>} the chips, in reading order
 */
export const listingKeyChips = (publicData = {}) => {
  const {
    tiretype,
    condition,
    rimWidthFront,
    diameter,
    etFront,
    numberOfBolts,
    boltCircle,
    adType,
  } = publicData;
  const chips = [];

  if (adType !== 'rim' && TYRE_TYPE_CHIPS[tiretype]) chips.push(TYRE_TYPE_CHIPS[tiretype]);
  if (condition) chips.push(condition === 'new' ? 'Nya' : 'Begagnade');

  if (adType !== 'tire') {
    if (rimWidthFront && diameter) {
      const et = etFront !== undefined && etFront !== null && etFront !== '' ? ` ET${decimal(etFront)}` : '';
      chips.push(`${decimal(rimWidthFront)}×${decimal(diameter)}${et}`);
    }
    /* Through boltCircleText first: Console's key for 139.7 is "1397"
     * (P25009-488), which decimal() alone printed as "6×1397". */
    if (numberOfBolts && boltCircle) {
      chips.push(`${numberOfBolts}×${decimal(boltCircleText(boltCircle) || boltCircle)}`);
    }
  }
  return chips;
};
